import { classnames } from '@aibees/shared/utils';
import { CardContent, CardHeader, Typography } from '@mui/material';
import { memo } from 'react';
import { SettingPageTabs } from '../../components/setting-page-tabs';
import * as Styled from './styles';
import * as SX from './sx';
import type { UserProfileProps as Props } from './types';

export const UserProfile = memo(({ className, config }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('UserProfile', className)}
      sx={SX.root}
      variant="outlined"
      headerDivider
    >
      <CardHeader
        title={
          <Typography fontSize="body1" fontWeight={700} color="grey.700">
            My Profile
          </Typography>
        }
      />

      <CardContent>
        <SettingPageTabs config={config} tabsContainerSx={SX.tabsContainer} />
      </CardContent>
    </Styled.Wrapper>
  );
});

UserProfile.displayName = 'UserProfile';
